import { SerializedProductInfo } from "./SerializedProductInfo";

export class SerializedProductsTable<PI extends SerializedProductInfo>
{
  products:PI[] = [];
}